<template>
  <div class="notAudit">
    <OATable ref="notAudit" :data="data" :columns="columns" :filterData="filterData" :selectionRow="false"
      @search="handleSearch" :loading="loading" @selectionChange="selectionChange">
      <div slot="button">
        <OAButton @click="exportExpress">新增</OAButton>
      </div>
    </OATable>
    <OAModalForm :title="titleText" :visible.sync="dialogVisible" :form-data="formData" @on-submit="submit"
      @on-cancel="cancel"></OAModalForm>
  </div>
</template>
<script>
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import expressApi from "@/services/express.js";
  import OAHandle from "@/components/OAHandle/OAHandle";
  import {
    getUrlQuery,
    getValue,
    resFilter,
    setValue,
    clearValue
  } from "@/common/util.js";
  import moment from "moment"
  import api from "@/api/apiConfig"
  export default {
    name: "notAudit",
    components: {
      OAModalForm,
      OAHandle
    },
    data() {
      let that = this;
      return {
        filterData: {
          employeeId: {
            formType: "a-auto-search",
            value: undefined,
            apiType: "getAll",
            col: 4,
            placeholder: "员工"
          },
        },
        columns: [{
            title: "员工",
            key: "employeeName"
          },
          {
            title: "id",
            key: "id",
          },
          {
            title: "创建人",
            key: "createrName"
          },
          {
            title: "创建日期",
            key: "createTime",
            // formatter(row, column, cellValue, index) {
            //   return moment(cellValue).format("YYYY-MM-DD")
            // }
          },
          {
            title: "操作",
            key: "",
            minWidth: 80,
            component: {
              name: OAHandle,
              props: {
                text: "删除",
                onClick: function (val) {
                  that.del(val.row);
                }
              }
            }
          }
        ],
        data: [],
        loading: false,
        checkList: [],
        dialogVisible: false,
        titleText: '快递免审核名单',
        formData: {
          employeeIdList: {
            formType: "a-auto-search",
            label: "员工：",
            value: undefined,
            apiType: "getAll",
            // col: 4,
            multiple: true,
            placeholder: "请选择员工"
          },
        },
      };
    },
    mounted() {},
    methods: {
      async handleSearch(val) {
        this.loading = true;
        let res = await expressApi.getExpressWhitelist(val);
        this.data = res.data.data;
        this.loading = false;
      },
      // 删除
      del(row) {
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async() => {
          await expressApi.deleteExpressWhitelist({id: row.id});
          this.handleSearch({});
        })
        .catch(() => {});
      },
      selectionChange(selection) {
        this.checkList = selection;
      },
      exportExpress() {
        this.dialogVisible = true
      },
      async submit() {
        let params = getValue(this.formData)
        await expressApi.addExpressWhitelist(params);
        this.handleSearch({});
        this.cancel()
      },
      cancel() {
        clearValue(this.formData)
        this.dialogVisible = false
      },
    }
  };

</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/set/notAudit.vue